import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePages from '@/views/homePages.vue'
import About from '@/views/aboutUs.vue'
import MyServices from '@/views/myServices.vue'
import MyCases from '@/views/myCases.vue'
import MyContact from '@/views/myContact.vue'


// 使用 VueRouter 插件
Vue.use(VueRouter)

// 定义应用的路由配置
const routes = [
    {
        path: '/',
        // redirect: '/homePages' // 将根路径重定向到首页界面
        component: HomePages,
        alias: '/homePages' // 添加这行
    },
    {
        path: '/homePages',
        name: 'HomePage',
        component: HomePages,

    },
    {
        path: '/about',
        name: 'About',
        component: About
    },
    {
        path: '/myServices',
        name: 'MyServices',
        component: MyServices
    },
    {
        path: '/myCases',
        name: 'MyCases',
        component: MyCases
    },
    {
        path: '/myContact',
        name: 'MyContact',
        component: MyContact
    },

]

// 创建并配置 Vue Router 实例
const router = new VueRouter({
    mode: 'history', // 可选: 'hash' | 'history' | 'abstract'
    base: process.env.BASE_URL,
    routes
})

export default router